import React from 'react'
import styles from './LocationCategory.module.scss'
import PropTypes from 'prop-types'
import { ReactComponent as Check } from '../../../assets/media/icons/icon-check.svg'

const LocationCategory = ({ category, title }) => {
    return (
        <div className={styles.container}>
            <h3 className={styles.title}>{title}</h3>
            <div className={styles.featuresContainer}>
                {category?.length > 0 &&
                    category.map(item => {
                        return (
                            <p className={styles.feature} key={item?.categoryId}>
                                <Check />
                                <span>{item?.categoryDisplayName}</span>
                            </p>
                        )
                    })}
            </div>
        </div>
    )
}

LocationCategory.propTypes = {
    category: PropTypes.array,
    title: PropTypes.string,
}

export default LocationCategory
